import { render, staticRenderFns } from "./phone-code.vue?vue&type=template&id=1c31ff3e&scoped=true"
import script from "./phone-code.vue?vue&type=script&lang=js"
export * from "./phone-code.vue?vue&type=script&lang=js"
import style0 from "./phone-code.vue?vue&type=style&index=0&id=1c31ff3e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c31ff3e",
  null
  
)

export default component.exports